<template>
    <div >
      <div class="invoiceTypeTitle">
        <!--<div class="invoiceTypeName">{{invoiceTypeName}}</div>-->
        <div class="invoiceTypeBox">
          <div class="invoiceTypeName">{{invoiceSplitName}}</div>
          <p class="invoiceCompanyName">{{invoiceHeader.cusName}}</p>
        </div>
        <div class="backBtn" @click="backPrev">返回</div>
      </div>
      <div class="invoiceLists" >
        <div class="invoiceList">
          <div class="invoiceCount">
            <!--<span>{{invoiceCompanyData.companyNo}}</span>-->
            <span>{{invoiceHeader.noticeId}}</span>
            <span>账单编号</span>
          </div>
          <!--<div class="invoiceCount">-->
            <!--<span>{{invoiceCompanyData.companyCount}}</span>-->
            <!--<span>发票张数</span>-->
          <!--</div>-->
          <!--<div class="invoiceCount">-->
            <!--<span>{{invoiceHeader.companyWage}}</span>-->
            <!--<span>工资代收代付</span>-->
          <!--</div>-->
          <div class="invoiceCount" v-if="invoiceHeader.accountItemId!=null">
          <span>{{invoiceHeader.amount | moneyFilter()}}</span>
          <span>{{invoiceHeader.accountItemId |dictFilter(dicts)}}</span>
          </div>
          <div class="invoiceCount">
            <span>{{invoiceHeader.serviceFee | moneyFilter }}</span>
            <span>服务费</span>
          </div>
          <div class="invoiceCount">
            <span>{{invoiceHeader.saleTax | moneyFilter}}</span>
            <span>销项税额</span>
          </div>
        </div>
        <div class="invoiceListBtn" v-if="invoiceActive === 3 && datas.length > 0">
          <el-button type="primary" size="small"  @click="insertEvent()">增加</el-button>
        </div>
      </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  export default {
    name: "invoiceTop",
    props:{
      invoiceHeader:{
        type:Object,
      },
      invoiceSplitName:{
        type:String,
      },
      datas: {
        type: Array,
        default: () =>([])
      },
      invoiceActive:{
        type:Number,
        default:1
      },
    },
    data(){
      return{

      }
    },
    computed: {
      ...mapGetters(['dicts']),
    },
    methods: {
      insertEvent(){
        this.$emit("insertEvent")
      },
      backPrev() {
        this.$emit('backPrev')
      },
    }
  };
</script>

<style scoped lang="scss">
  .invoiceTypeTitle{
    display: flex;
    justify-content: space-between;
    .invoiceTypeBox{
      display: flex;
    }
    .invoiceTypeName{
      width: 96px;
      height: 36px;
      color: #ffffff;
      font-size: 12px;
      padding-left: 16px;
      margin-right: 10px;
      line-height: 34px;
      background: url("~@/assets/img/form/invoiceName.png");
    }
    .invoiceCompanyName{
      color:#000;
      font-size: 16px;
      margin-top: 1px;
      line-height: 36px;
    }
    .backBtn{
      width: 40px;
      height: 26px;
      line-height: 26px;
      margin-right: -20px;
      background: #409eff;
      border-radius: 100px 0 0 100px;
      color: #fff;
    }
  }
  .invoiceLists{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  .invoiceList{
    display: flex;
    flex:1;
  .invoiceCount{
    display: flex;
    flex-direction: column;
    align-items: center;
    flex:1;
    position: relative;
    margin: 10px 0;
  &::before{
     content:"";
     position: absolute;
     right:0;
     top:50%;
     margin-top: -15px;
     height: 30px;
     width: 1px;
     background:#ccc;
   }
  &:last-child::before{
     display: none;
   }
  span{
    color:#000;
    font-size: 16px;
    line-height: 26px;
  }
  span+span{
    color:#999;
    font-size: 12px;
    line-height: 22px;
    padding:0px 8px;
  }
  }
  }
  .invoiceListBtn{
    margin-left: 10px;
  .el-button{
    width: 53px;
  }
  }
  }
</style>
